var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"e3a4833261f1c767fb35206fdde54c3b929e9b20"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web@grailed"]={id:"e3a4833261f1c767fb35206fdde54c3b929e9b20"};
      